import { render, staticRenderFns } from "./LocationSettingsIntegrationCard.vue?vue&type=template&id=18622daf"
import script from "./LocationSettingsIntegrationCard.vue?vue&type=script&lang=js"
export * from "./LocationSettingsIntegrationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports